<template>
    <div class="row left-nav-collapsible">
        <div v-if="detailPageOpen" id="detail-page-open">
            <button class="btn details-open-btn" type="button" @click="onDetailPageOpenClose(false)">
                <span> <i class="fa fa-caret-right"></i></span>
            </button>
        </div>
        <TransitionGroup :name="'slide'" key="detail">
            <div v-if="showCloseBtn && !detailPageOpen" id="detail-page-close" key="close">
                <button class="btn text-start details-open-btn" type="button" @click="onDetailPageOpenClose(true)">
                    <span> <i class="fa fa-caret-left"></i></span>
                </button>
            </div>
            <div v-if="!detailPageOpen" id="details-col" @mouseover="onDetailPageHover(true)" key="details-col">
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-header-title">History</h5>
                        <button type="button" data-bs-toggle="collapse" href="#collapse-history-div"
                            aria-expanded="true" aria-controls="collapse-history-div" id="collapse-btn"
                            class="btn  btn-sm"> <i class="fa fa-chevron-up float-end"></i></button>
                    </div>
                    <div id="collapse-history-div" class="collapse show" aria-labelledby="collapse-btn-1">
                        <div class="card-body p-3">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <div class="limit-col input-group input-group-sm">
                                        <label class="input-group-text" for="limit">Limit</label>
                                        <input class="form-control" type="number" v-model.number="limit"
                                            :disabled="false" id="limit" style="width: 60px; height: 30px;" />
                                    </div>
                                </div>
                                <button class="btn btn-primary btn-sm" type="button" @click="fetchChatHistory(true)"
                                    :disabled="loading">
                                    <div v-if="loading" class="spinner-border spinner-border-sm mt-1" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                    <div v-else>
                                        <i class="fa fa-refresh" aria-hidden="true"></i>
                                    </div>
                                </button>
                            </div>
                            <div v-if="chats && chats.length > 0">
                                <list-group id="mmd-chat-history" :editMode="true" :title="'Chat History'" :list="chats"
                                :activeListItem="currentChat?.resourceId" listItemKey="resourceId"
                                :listItemTitle="constructChatTitle" @deleteBtnClick="deleteChatHistory"
                                @selectBtnclick="handleSelect"></list-group>
                            </div>
                            <div v-else>
                                <div class="text-center">
                                    {{ loading ? 'Loading chats...' : 'No chats found!' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" v-if="chats?.length > 0 && currentChat">
                    <div class="card-header">
                        <h5 class="card-header-title">Details</h5>
                        <button type="button" data-bs-toggle="collapse" href="#collapse-details-div"
                            aria-expanded="true" aria-controls="collapse-details-div" id="collapse-btn"
                            class="btn  btn-sm"> <i class="fa fa-chevron-up float-end"></i></button>
                    </div>
                    <div id="collapse-details-div" class="collapse show" aria-labelledby="collapse-btn-1">
                        <div class="card-body p-3">
                            <input-field :editable="false" :label="'ID'" type="text"
                                :modelValue="currentChat.resourceId" :toolTip="'Chat Id'" />
                            <input-field :editable="false" :label="'Title'" type="text" :modelValue="currentChat.title"
                                :toolTip="'Chat Title'" />
                            <input-field :editable="false" :label="'Mode'" type="text"
                                :modelValue="pysparkMode ? 'PySpark' : 'Mapper'"
                                :toolTip="'Job type generated(mapper/pyspark)'" />
                            <div v-if="customInstructions">
                                <input-field :editable="false" :label="'Custom Instructions'" type="textarea"
                                    :modelValue="customInstructions"
                                    :toolTip="'Custom instructions for the mapping process(given by user)'" />
                            </div>
                            <input-field :editable="false" :label="'Created At'" type="text"
                                :modelValue="DateTimeFormat(currentChat.createdAt)"
                                :toolTip="'Created Timestamp'" />
                            <input-field :editable="false" :label="'Updated At'" type="text"
                                :modelValue="DateTimeFormat(currentChat.updatedAt)" :toolTip="'Updated Timestamp'" />
                            <div class="text-end">
                                <button class="btn btn-primary btn-sm" @click="showinputFile">
                                    Input File
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col" id="main-col" @mouseover="onDetailPageHover(false)" key="main-col">
                <div v-if="chats?.length > 0 && currentChat && currentMessages?.length > 0">
                    <tabs :tabs="tabItems" :btnTabs="true">
                        <template v-slot:audit>
                            <div v-if="auditReport" class="card">
                                <div class='card-body markdown-content custom-class'>
                                    <Markdown :content="auditReport" />
                                </div>
                            </div>
                            <div v-else class="card card-body text-center">
                                No data found!
                            </div>
                        </template>
                        <template v-slot:mapper>
                            <div v-if="textResponse">
                                <div class="row">
                                    <div class="col-4">
                                        <div class="card">
                                            <div class='card-body custom-class'>
                                                <div v-if="textResponse" class="float-end">
                                                    <button class="btn btn-primary btn-sm" @click="showModal({ component: 'mapperDetailView', data: { response: { text_response: textResponse }, screenlarge: true } })">
                                                        <i class="fa fa-up-right-and-down-left-from-center"></i>
                                                    </button>
                                                </div>
                                                <Markdown :content="textResponse" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-8">
                                        <job-editor v-model="yamlContent" :activeTab="activeFileTab" :customHeight="'100%'"></job-editor>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="card card-body text-center">
                                No data found!
                            </div>
                        </template>
                        <template v-slot:advisor>
                            <div v-if="advisorResponse" class="card">
                                <div class='card-body markdown-content custom-class'>
                                    <Markdown :content="advisorResponse"></Markdown>
                                </div>
                            </div>
                            <div v-else class="card card-body text-center">
                                No data found!
                            </div>
                        </template>
                        <template v-slot:graph>
                            <div class="card">
                                <div class='card-body'>
                                    <div ref="graphContainer" class="graph-container d-flex justify-content-center">
                                    </div>
                                </div>
                            </div>
                        </template>
                    </tabs>
                </div>
                <div v-else>
                    <div v-if="loading || messagesLoading" class="card card-body">
                        <div class="d-flex justify-content-center">
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center card card-body">
                        No data found!
                    </div>
                </div>
            </div>
        </TransitionGroup>
    </div>
</template>
<script>
import Tabs from "../../components/Tabs.vue";
import Markdown from "../../components/Markdown.vue";
import JobEditor from "../../components/sandbox/JobEditor.vue";
import { DateTimeFormat, relativeTime } from '../../utils/commonFunction';
import InputField from "../../components/InputField.vue";
import ListGroup from "../../components/ListGroup.vue";
import { mapState, mapActions } from 'vuex'
import { nextTick } from "vue";
import dayjs from 'dayjs'
import * as d3 from "d3";
import untruncateJson from "untruncate-json";
export default {
    name: "Map My Data Invocations",
    components: { Tabs, Markdown, JobEditor, InputField, ListGroup },
    data() {
        return {
            loading: false,
            messagesLoading: false,
            showCloseBtn: false,
            detailPageOpen: false,
            tabItems: [
                {
                    name: "Audit",
                    id: "id1",
                    slot: "audit"
                },
                {
                    name: "Mapping Config",
                    id: "id2",
                    slot: "mapper"
                },
                {
                    name: "Advisor",
                    id: "id3",
                    slot: "advisor"
                },
                {
                    name: "Graph",
                    id: "id4",
                    slot: "graph",
                    onClick: () => {
                        nextTick().then(() => {
                            this.drawGraph(this.graphResponse)
                        })
                    }
                },
            ],

            // chat history
            currentChat: null,
            currentMessages: null,
            limit: null,
        }
    },
    computed: {
        ...mapState({
            chats: state => state.amdp.mmdChats,
            currentChat: state => state.amdp.mmdCurrentChat,
            chatLimit: state => state.amdp.mmdChatLimit,
        }),
        pysparkMode() {
            if (this.currentMessages && this.currentMessages.length >= 1) {
                let pysparkMode = this.currentMessages[0].content?.mode == "pyspark"
                return pysparkMode
            }
            return false
        },
        fileType() {
            if (this.currentMessages && this.currentMessages.length >= 1) {
                let file_type = this.currentMessages[0].content?.file_type
                return file_type ? file_type : "csv";
            }
            return ""
        },
        inputFile() {
            if (this.currentMessages && this.currentMessages.length >= 1) {
                let file = this.currentMessages[0].content?.file_content
                return file ? file : null;
            }
            return null
        },
        textResponse() {
            if (this.currentMessages && this.currentMessages.length >= 2) {
                let textResponse = this.currentMessages[1].content?.text_response
                return textResponse ? textResponse : null;
            }
            return null
        },
        auditReport() {
            if (this.currentMessages && this.currentMessages.length >= 1) {
                let auditReport = this.currentMessages[0].content?.audit_report
                return auditReport ? auditReport : null;
            }
            return null
        },
        yamlContent() {
            if (this.currentMessages && this.currentMessages.length >= 2) {
                let generatedFiles = this.currentMessages[1].content?.files
                let files = {}
                if (generatedFiles) {
                    for (const file of generatedFiles) {
                        files[file.name] = file.content ? file.content : ""
                    }
                }
                return files
            }
            return {}
        },
        activeFileTab() {
            if (this.currentMessages && this.currentMessages.length >= 2) {
                let generatedFiles = this.currentMessages[1].content?.files
                return generatedFiles ? generatedFiles[0].name : ""
            }
            return ""
        },
        advisorResponse() {
            if (this.currentMessages && this.currentMessages.length >= 2) {
                let advisorResponse = this.currentMessages[1].content?.advisor_response
                return advisorResponse ? advisorResponse : null;
            }
            return null
        },
        graphResponse() {
            if (this.currentMessages && this.currentMessages.length >= 2) {
                let graphResponse = this.currentMessages[1].content?.graph_response
                return graphResponse ? graphResponse : null;
            }
            return null
        },
        customInstructions() {
            if (this.currentMessages && this.currentMessages.length >= 1) {
                let customInstructions = this.currentMessages[0].content?.custom_instructions
                return customInstructions ? customInstructions : null;
            }
            return null
        },
    },
    methods: {
        ...mapActions({
            showModal: "showModal",
            getChats: "amdp/getChats",
            getChatMessages: "amdp/getChatMessages",
        }),
        deleteChatHistory(chat) {
            let data = {
                feature: "map_my_data",
                chats: [chat],
                refreshChatsFunction: this.fetchChatHistory,
                screensize: 'xl'
            }
            this.showModal({ component: "deleteChatHistory", data: data });
        },
        constructChatTitle(chat) {
            const createdTime = this.convertToRelativeTime(chat.createdAt);
            return `<span><strong>${chat.title}</strong></span><span class="badge badge-secondary" style="align-self: flex-start; display: inline-block;">${createdTime}</span>`;
        },
        drawGraph(data) {
            const width = this.$refs.graphContainer.clientWidth;
            const height = 600;

            // Remove old SVG if it exists
            d3.select(this.$refs.graphContainer).select("svg").remove();

            // Create new SVG with zoom/pan support
            const svg = d3.select(this.$refs.graphContainer)
                .append("svg")
                .attr("width", width)
                .attr("height", height)
                .call(
                    d3.zoom()
                        .scaleExtent([0.5, 5]) // Min zoom 50%, max zoom 500%
                        .on("zoom", (event) => {
                            g.attr("transform", event.transform);
                        })
                );

            // Add a group element for panning/zooming
            const g = svg.append("g");
            this.simulation = d3.forceSimulation(data.nodes)
                .force("link", d3.forceLink(data.edges).id(d => d.id).distance(50))
                .force("charge", d3.forceManyBody().strength(-200))
                .force("center", d3.forceCenter(width / 2, height / 2));

            // Create edges (links)
            const link = g.selectAll(".link")
                .data(data.edges)
                .enter()
                .append("line")
                .attr("stroke", "#999")
                .attr("stroke-width", 1.5)
                .attr("stroke-opacity", 0.6);

            // Create node groups
            const node = g.selectAll(".node")
                .data(data.nodes)
                .enter()
                .append("g")
                .attr("class", "node")
                .call(
                    d3.drag()
                        .on("start", (event, d) => {
                            if (!event.active) this.simulation.alphaTarget(0.3).restart();
                            d.fx = d.x;
                            d.fy = d.y;
                        })
                        .on("drag", (event, d) => {
                            d.fx = event.x;
                            d.fy = event.y;
                        })
                        .on("end", (event, d) => {
                            if (!event.active) this.simulation.alphaTarget(0);
                            d.fx = null;
                            d.fy = null;
                        })
                );

            // Add circles for nodes
            node.append("circle")
                .attr("stroke", "white") // Border color
                .attr("stroke-width", 1.5) // Border thickness
                .attr("r", d => { // Circle radius
                    if (d.type === "prsn") return 15;
                    if (d.type === "org" || d.type === "hh") return 20;
                    return 12;
                })
                .attr("fill", d => { // Circle colour
                    if (d.type === "prsn") return "blue";
                    if (d.type === "ck") return "orange";
                    if (d.type === "statid") return "green";
                    if (d.type === "ip") return "purple";
                    if (d.type === "org" || d.type === "hh") return "red";
                    return "gray";
                });

            // Add icons inside the circles
            node.append("text")
                .attr("class", "fa")  // Font Awesome class for styling
                .attr("font-family", "FontAwesome")
                .attr("text-anchor", "middle")

                //.attr("x", d => (d.type === "prsn" || d.type === "cookie" || d.type === "statid" ? -6 : -4)) // Adjust horizontal position
                .attr("y", 5)  // Adjust vertical position
                .attr("x", 0)
                .attr("fill", "white")
                .attr("font-size", d => (d.type === "prsn" ? "14px" : d.type === "org" ? "18px" : d.type === "statid" ? "11px" : "13px"))
                .text(d => {
                    if (d.type === "prsn") return "\uf007"; // person_icon
                    if (d.type === "ck") return "\uf564"; // cookie icon
                    if (d.type === "statid") return "\uf390"; // statid icon
                    if (d.type === "ip") return "\uf6ff"; // network icon
                    if (d.type === "hh") return "\uf015"; // house icon
                    if (d.type === "org") return "\ue533"; // org icon
                    return "\u003f"; // unknown icon
                });

            // Tooltip for nodes
            node.on("mouseover", (event, d) => {
                const tooltip = document.createElement("div");
                tooltip.innerHTML = `<strong>Type: ${d.type}</strong><br>Domain: ${d.domain}<br>Key: ${d.key}`;
                tooltip.className = "graph-tooltip";
                tooltip.style.left = event.pageX + 5 + "px";
                tooltip.style.top = event.pageY + 5 + "px";
                document.body.appendChild(tooltip);
            });
            node.on("mouseout", () => {
                document.querySelectorAll(".graph-tooltip").forEach(tooltip => tooltip.remove());
            });

            // Update positions on simulation tick
            this.simulation.on("tick", () => {
                link
                    .attr("x1", d => d.source.x)
                    .attr("y1", d => d.source.y)
                    .attr("x2", d => d.target.x)
                    .attr("y2", d => d.target.y);
                node.attr("transform", d => `translate(${d.x},${d.y})`);
            });
        },
        onDetailPageOpenClose(value) {
            this.showCloseBtn = false;
            this.detailPageOpen = value;
        },
        onDetailPageHover(value) {
            this.showCloseBtn = value;
        },
        showinputFile() {
            this.showModal({
                component: "AgentInputFileViewer",
                data: {
                    title: 'Map My Data - File Viewer',
                    file: {
                        name: `InputFile.${this.fileType}`,
                        content: this.inputFile,
                    },
                    screensize: 'xl'
                }
            });
        },
        async fetchChatHistory(forceGet = false) {
            this.loading = true;
            await this.getChats({ feature: "map_my_data", limit: this.limit, forceGet: forceGet }).catch((error) => {
                console.error("Error getting chat history: ", error);
                let toastoptions = {
                    message: error.response?.data.error ? error.response.data.error : error.message,
                    type: "error",
                };
                this.$store.dispatch('addToast', toastoptions);
            })
            if (this.chats && this.chats.length > 0) {
                this.handleSelect(this.chats[0], forceGet = true);
            }
            this.loading = false;
        },
        async handleSelect(data, forceGet = false) {
            if (!forceGet && this.currentChat?.resourceId == data.resourceId) return
            this.currentChat = data;

            // get current chat's messages
            this.messagesLoading = true;
            this.currentMessages = null;
            await this.getChatMessages({ feature: "map_my_data", resourceId: this.currentChat.resourceId }).then((response) => {
                this.currentMessages = response.data ? response.data : [];
            }).catch((error) => {
                console.error("Error getting chat messages: ", error);
                let toastoptions = {
                    message: error.response?.data.error ? error.response.data.error : error.message,
                    type: "error",
                };
                this.$store.dispatch('addToast', toastoptions);
            }).finally(() => {
                this.messagesLoading = false;
            })

            // draw graph when another chat is selected when 'Graph' tab is active
            if (this.$store.state.activeTab == 'Graph') {
                nextTick().then(() => {
                    this.drawGraph(this.graphResponse)
                })
            }
        },
        convertToRelativeTime(timestamp) {
            return relativeTime(Date.now(), dayjs(timestamp));
        },
        DateTimeFormat,
    },
    watch: {
        limit(newLimit) {
            this.$store.dispatch("amdp/setMMDChatLimit", newLimit);
        },
    },
    async mounted() {
        this.$emit("setChat", null);
        this.limit = this.chatLimit;
        await this.fetchChatHistory();
    },
    emits: ["setChat"]
}
</script>
<style scoped>
.limit-col {
    width: 110px;
}

.card-header {
    background-color: #F9FBFD;
    text-transform: uppercase;
    color: #95AAC9;
    height: 40px;
}

.collapsed .fa {
    transform: rotate(180deg);
}

.custom-class {
    width: 100%;
    overflow-x: scroll;
}
</style>